export { default } from "/Users/Quentin/Documents/Projects/Web/Remix/comment-decorations/app/routes/index.tsx";